<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos de la operación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Fecha operación *</span>
          </div>
          <div>
            <flat-pickr data-vv-as="FECHA" name="fecha" v-validate="'required'" :config="configdateTimePicker" v-model="operacion.fecha" />
            <span class="text-danger text-sm"  v-show="errors.has('fecha')">{{ errors.first('fecha') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Tipo de cliente *</span>
          </div>
          <div>
            <select-tipo-cliente v-model="operacion.tipoCliente" :tipoClienteSelected="operacion.tipoCliente"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Operador *</span>
          </div>
          <div>
            <select-operador v-model="operacion.operador" :operadorSelected="operacion.operador" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Estado</span>
          </div>
          <div>
            <select-val-estado v-model="operacion.valEstado" categoria="OPERACION" :estadoSelected="operacion.valEstado.estado" :disabled="valEstadoDisabled" />
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos del cliente" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">DNI/CIF *</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.dni" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Fecha nacimiento</span>
          </div>
          <div>
            <flat-pickr name="fechaNacimiento" :config="configdateTimePicker" v-model="cliente.persona.fechaNacimiento" disabled />
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Nombre o razón social *</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.nombre" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.persona.apellidos" disabled/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Móvil de contacto *</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.telefono" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">E-mail *</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="cliente.email" disabled/>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos bancarios" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          ¿El titular de la cuenta bancaria es el cliente?
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.titularIgualCliente" vs-name="titularIgualCliente" vs-value="S">Sí</vs-radio>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.titularIgualCliente" vs-name="titularIgualCliente" vs-value="N">No</vs-radio>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Cuenta bancaria *</span>
          </div>
          <div>
            <!-- https://es.iban.com/estructura -->
            <vs-input class="w-full" data-vv-as="IBAN" v-validate="'checkIBAN'" name="iban" placeholder="ES0000000000000000000000" 
              v-model="operacion.iban"/>
            <span class="text-danger text-sm"  v-show="errors.has('iban')">{{ errors.first('iban') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.titularIgualCliente === 'N'">
          <div>
            <span class="campoObligatorio">DNI/CIF *</span>
          </div>
          <div>
            <vx-input-group>
              <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="titular.persona.dni"
                v-on:keyup="borrarCamposTitular" @input="v => { titular.persona.dni = v.toUpperCase()}"/>
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona('TITULAR')" />
                </div>
              </template>
            </vx-input-group>
            <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
          </div>
        </div>
      </div>
        <div class="vx-row mb-2" v-if="operacion.titularIgualCliente === 'N'">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">Nombre o razón social *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreTitular" v-model="titular.persona.nombre"
                :disabled="titularDisabled" @input="v => { titular.persona.nombre = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Apellidos</span>
            </div>
            <div>
              <vs-input class="w-full" name="apellidos" v-model="titular.persona.apellidos" :disabled="titularDisabled" 
                @input="v => { titular.persona.apellidos = v.toUpperCase()}"/>
            </div>
          </div>
        </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Notas" title-color="dark" collapseAction>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-textarea class="w-full" name="observaciones" v-model="operacion.observaciones" height="120px" @input="v => { operacion.observaciones = v.toUpperCase()}"/>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Usuario creador de la operación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/4 w-full">
          <div>
            <span>Usuario</span>
          </div>
          <div>
            <vs-input class="w-full" name="username" v-model="operacion.usuario.username" disabled />
          </div>
        </div>
        <div class="vx-col sm:w-1/4 w-full" >
          <div>
            <span>DNI</span>
          </div>
          <div>
            <vs-input class="w-full" name="username" v-model="operacion.usuario.dni" disabled />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Nombre y apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" name="username" v-model="usuarioNombreCompleto" disabled />
          </div>
        </div>
      </div>
    </vx-card>

    <popup-buscar-persona :popupProps="popupProps" @aceptar="popupBuscarPersonaAction" ref="consultarDni" />

    <vs-popup title="Para este tipo de cliente es obligatorio dar de alta un decisor" 
      :active.sync="popupAvisoEmpresaSinDecisor" 
      button-close-hidden
    >
      <p class="campoObligatorio">
        Ha cambiado el tipo de cliente de la operación a EMPRESA, sin embargo no existe un decisor.
        Debe dar de alta un decisor.
      </p>
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="crearDecisor">Crear decisor</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="popupAvisoEmpresaSinDecisor=false">Cancelar</vs-button>
        
      </div>
    </vs-popup>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import personasStore from '@/store/gestion/personas/index.js'

import selectValEstado from '@/views/common-components/selectValEstado'
import selectOperador from '@/views/common-components/selectOperador'
import selectTipoCliente from '@/views/common-components/selectTipoCliente'
import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'
import popupBuscarPersona from '@/views/common-components/popupBuscarPersona'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'OperacionesEditOperacion',
  components: {
    selectValEstado,
    selectOperador,
    selectTipoCliente,
    selectValMunicipio,
    selectValProvincia,
    popupBuscarPersona,
    flatPickr,
    SpanishLocale
  },
  data () {
    return {
      operacion: {},
      cliente: {},
      decisor: {},
      titular: {},
      operacionPersona: {},
      titularId: null,

      // Propiedades para deshabilitar campos que se poden obter si a persoa xa existe na BD
      titularDisabled: true,

      // Popup para avisar de que se cambiou o tipo de titular a EMPRESA e é necesario crear un DECISOR
      popupAvisoEmpresaSinDecisor: false,

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      },
      // popupBuscarPersona
      popupProps: {
        activo: false,
        dni: null,
        relacion: ''  // Relación da persoa coa operación: CLIENTE, DECISOR ou TITULAR
      }
    }
  },
  computed: {
    usuarioNombreCompleto () {
      return `${this.operacion.usuario.nombre} ${this.operacion.usuario.apellidos}`
    },
    /**
     * valEstado: unha operación dase de alta con estado 'INCOMPLETA'. Este estado nunca varía ata que un usuario completa a 
     * operación (porcentajeCompletado===100) e lle da ao botón de 'Lanzar' ou de 'Pendiente de firma'. Nese momento cámbiase o estado a algún 
     * deses dous (LANZADA ou PENDIENTE DE FIRMA) e a partir dese momento valEstado está habilitado PERO SÓ para administradores.
     */
    valEstadoDisabled () {
      let disabled = true
      if (this.operacion.porcentajeCompletado === 100 
          && this.operacion.valEstado.estado !== 'INCOMPLETA'
          && this.$store.state.AppActiveUser.userRole === 'ROLE_ADMIN') disabled = false
      return disabled
    },
    validateForm () {
      if (this.errors.any() 
        || this.operacion.fecha === null || this.operacion.fecha === ''
        || this.operacion.tipoCliente === null || this.operacion.tipoCliente === undefined 
        || this.operacion.operador === null || this.operacion.operador === undefined
        // || this.operacion.valEstado === null || this.operacion.valEstado === undefined
        || this.operacion.iban === null || this.operacion.iban === undefined 
        || (this.operacion.titularIgualCliente === 'N' 
          && (this.titular.persona.dni === null || this.titular.persona.dni === undefined
            || this.titular.persona.nombre === null || this.titular.persona.nombre === undefined))
        // || this.empresaSinDecisor
      ) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    // empresaSinDecisor () {
    //   // Seleccionouse como tipo de cliente EMPRESA pero o decisor está sen crear (Object.keys(this.decisor).length === 0)
    //   if (this.empresaSinDecisor) this.popupAvisoEmpresaSinDecisor = true
    // }
  },
  methods: {
    async guardar () {
      if (!this.validateForm) return

      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      let errorAlGuardar = false

      // Se non se modifica o campo ESTADO do formulario, devolve un obxecto en lugar dun string e é necesario enviar un string
      if (typeof this.operacion.valEstado === 'object') {
        const estado = `/api/val_estados/${this.operacion.valEstado.id}`
        delete this.operacion.valEstado
        this.operacion.valEstado = estado
      }

      // Comprobamos se se modificou o titular da conta para actualizalo. Se se cambiou o valor da pregunta de se o titular bancario é o mesmo que o cliente...
      if (this.operacion.titularIgualCliente !== this.$store.state.operacionesStore.operacion.titularIgualCliente 
          || this.titularId !== this.titular.persona.id) {
        this.operacionPersona.id = this.titular.id  // Asignamos o id de OperacionPersona a cambiar (o do titular)
        if (this.operacion.titularIgualCliente === 'S') {  
          this.operacionPersona.persona = `/api/personas/${this.cliente.persona.id}`
          // Gardamos a OperacionPersona
          errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', this.operacionPersona)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
        } else {  
          if (this.titularId === null) {  // Non se atopou o DNI introducido polo que hai que crear a persoa
            const tc = {}
            tc.dni = this.titular.persona.dni
            tc.nombre = this.titular.persona.nombre
            tc.apellidos = this.titular.persona.apellidos
            // Gardamos a nova persoa
            errorAlGuardar = await this.$store.dispatch('personasStore/addPersona', tc)
              .then((response)   => { 
                this.titularId = response.data.id
                this.showUpdateSuccess()
              })
              .catch((error) => {
                this.showUpdateError(error)
                return true
              })
          }

          if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

          this.operacionPersona.persona = `/api/personas/${this.titularId}`
          // Gardamos a OperacionPersona
          errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', this.operacionPersona)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
        }
      }

      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

      const o = {}
      o.id = this.operacion.id
      o.fecha = this.operacion.fecha
      o.tipoCliente = this.operacion.tipoCliente
      o.operador = this.operacion.operador
      o.valEstado = this.operacion.valEstado
      o.titularIgualCliente = this.operacion.titularIgualCliente
      o.iban = this.operacion.iban
      o.observaciones = this.operacion.observaciones
      // Gardamos a operación
      await this.$store.dispatch('operacionesStore/updateOperacion', o)
        .then(() => { 
          this.showUpdateSuccess()
        })
        .catch((error) => {
          this.showUpdateError(error)
        })

      // Actualizamos a operación no State
      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)

      // Si se cambiou o tipo de cliente a EMPRESA e non ten un decisor asociado (podería telo se inicialmente se creou como empresa e logo se cambiou o timpo de cliente)
      // mostramos un aviso de que debe crealo
      if (this.operacion.tipoCliente === 'EMPRESA'
        && this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR') === undefined) {
        this.popupAvisoEmpresaSinDecisor = true
      }

      this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    },
    showUpdateSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'OPERACIÓN ACTUALIZADA',
        text: 'La operación ha sido guardada correctamente.'
      })
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    showErroDeDatos (erro) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error de validación de datos',
        text: erro
      })
    },
    borrarCamposTitular () {
      // Habilitamos os campos
      this.titularDisabled = false
      // Borramos os campos
      this.titularId = null
      this.titular.persona.nombre = null
      this.titular.persona.apellidos = null
      // Deshabilitamos os campos
      this.titularDisabled = true
    },
    abrirPopupBuscarPersona () {
      if (!this.errors.has('dniTitular') && this.titular.persona.dni !== null && this.titular.persona.dni !== undefined) {
        // Veriricamos que non se intruduce o mesmo DNI que o do cliente ou decisor
        if (this.titular.persona.dni === this.cliente.persona.dni) {
          this.showErroDeDatos('Se ha marcado que el titular de la cuenta y el cliente son distintos, sin embargo tienen el mismo DNI') 
        } else {
          this.popupProps.dni = this.titular.persona.dni
          this.titularId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
          // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
          this.borrarCamposTitular()
          // Chamamos ao método do popup
          this.$refs.consultarDni.consultarDni()
        }
      }
    },
    popupBuscarPersonaAction (persona) {
      this.popupProps.activo = false  // Pechamos o popup
      if (persona.existe) {
        this.titularId = persona.personaId // Asignamos o id da persoa atopada para gardar na operación
        this.titularDisabled = false
        this.titular.persona.nombre = persona.nombre
        this.titular.persona.apellidos = persona.apellidos
        this.titularDisabled = true
      } else {
        this.titularDisabled = false
      }
    },
    crearDecisor () {
      //this.$emit('cambiarSolapa', 2)
      this.popupAvisoEmpresaSinDecisor = false
      // Cambiamos a TRUE a propiedade 'crearDecisor' no estado para que na solapa 'Decisor' nos permita dar a alta
      // await this.$store.dispatch('operacionesStore/crearDecisor', true)
      this.$nextTick(() => {
        this.$emit('cambiarSolapa', 2)
      })
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))

    // No caso de EMPRESA comprobamos se existe o decisor
    if (this.operacion.tipoCliente === 'EMPRESA'
      && this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR') !== undefined) {
      this.decisor = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'DECISOR')))
    }
    this.titular = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'TITULAR')))
    if (this.operacion.titularIgualCliente === 'N') {
      this.titularId = this.titular.persona.id  // Gardamos o id do titular orixinal para saber se posteriormente se modifica
    }
  }
}
</script>

